import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions Générales de Vente (CGV)</h1>
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500">Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          
          <p className="text-lg font-semibold mt-6">Sibystock - Propriété de Sibyagence</p>
          
          <h2 className="text-2xl font-bold mt-8">1. Préambule</h2>
          <p>Les présentes Conditions Générales de Vente (CGV) régissent les relations entre :</p>
          <ul className="list-disc pl-6">
            <li>Sibyagence, société propriétaire de la plateforme Sibystock (accessible à l'adresse sibystock.com),</li>
            <li>Et tout utilisateur, particulier ou professionnel, utilisant les services de Sibystock (ci-après désigné « le Client »).</li>
          </ul>
          <p>En accédant et en utilisant Sibystock, le Client accepte sans réserve les présentes CGV.</p>

          <h2 className="text-2xl font-bold mt-8">2. Services proposés</h2>
          <p>Sibystock est une plateforme spécialisée dans la gestion de stocks, offrant des outils numériques pour :</p>
          <ul className="list-disc pl-6">
            <li>Le suivi des stocks en temps réel,</li>
            <li>La gestion des ventes, des bénéfices et des retours,</li>
            <li>Le contrôle des dettes,</li>
            <li>L'analyse de performance via tableaux de bord personnalisés.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">3. Commandes et accès aux services</h2>
          <h3 className="text-xl font-semibold mt-6">3.1. Création d'un compte</h3>
          <p>Pour utiliser les services de Sibystock, le Client doit créer un compte en fournissant des informations exactes et à jour.</p>

          <h3 className="text-xl font-semibold mt-6">3.2. Commandes</h3>
          <p>L'accès à certaines fonctionnalités de la plateforme peut nécessiter un abonnement ou un paiement ponctuel. Ces offres sont présentées sur le site et détaillées dans la section « Tarifs ».</p>

          <h3 className="text-xl font-semibold mt-6">3.3. Validation</h3>
          <p>La commande est confirmée une fois le paiement validé et un email de confirmation envoyé.</p>

          <h2 className="text-2xl font-bold mt-8">4. Tarifs et paiement</h2>
          <h3 className="text-xl font-semibold mt-6">4.1. Tarification</h3>
          <p>Les tarifs des services sont indiqués en euros (€) et incluent, le cas échéant, les taxes applicables (TVA).</p>

          <h3 className="text-xl font-semibold mt-6">4.2. Modalités de paiement</h3>
          <p>Les paiements se font par carte bancaire, virement ou tout autre moyen sécurisé proposé sur le site.</p>

          <h3 className="text-xl font-semibold mt-6">4.3. Modification des prix</h3>
          <p>Sibyagence se réserve le droit de modifier les prix des abonnements et services, sous réserve d'un préavis de 30 jours pour les abonnés existants.</p>

          <h2 className="text-2xl font-bold mt-8">5. Droits et obligations des parties</h2>
          <h3 className="text-xl font-semibold mt-6">5.1. Obligations de Sibyagence</h3>
          <p>Sibyagence s'engage à :</p>
          <ul className="list-disc pl-6">
            <li>Fournir un service conforme à la description,</li>
            <li>Garantir la confidentialité et la sécurité des données personnelles du Client conformément au RGPD,</li>
            <li>Assurer un support technique en cas de problème.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6">5.2. Obligations du Client</h3>
          <p>Le Client s'engage à :</p>
          <ul className="list-disc pl-6">
            <li>Utiliser Sibystock conformément à la loi et aux présentes CGV,</li>
            <li>Fournir des informations exactes et les mettre à jour,</li>
            <li>Régler les montants dus dans les délais impartis.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">6. Résiliation et gestion des abonnements</h2>
          <h3 className="text-xl font-semibold mt-6">6.1. Rétrogradation des abonnements</h3>
          <p>Le Client peut demander la rétrogradation de son abonnement à tout moment pour passer à un plan gratuit. Cette opération peut être effectuée directement via son compte utilisateur.</p>

          <h3 className="text-xl font-semibold mt-6">6.2. Suppression de compte</h3>
          <p>Pour supprimer définitivement son compte, le Client doit envoyer une demande par email à contact@sibyagence.com. La suppression sera effective après confirmation de l'identité du demandeur et traitement de la demande.</p>

          <h3 className="text-xl font-semibold mt-6">6.3. Résiliation par Sibyagence</h3>
          <p>Sibyagence se réserve le droit de suspendre ou résilier un compte en cas de non-respect des présentes CGV ou en cas de fraude.</p>

          <h2 className="text-2xl font-bold mt-8">7. Protection des données personnelles (RGPD)</h2>
          <h3 className="text-xl font-semibold mt-6">7.1. Données collectées</h3>
          <p>Les données collectées incluent, mais ne sont pas limitées à :</p>
          <p>Nom, prénom, adresse e-mail, numéro de téléphone, informations de paiement.</p>

          <h3 className="text-xl font-semibold mt-6">7.2. Finalité du traitement</h3>
          <p>Les données sont collectées pour :</p>
          <ul className="list-disc pl-6">
            <li>La gestion des comptes et abonnements,</li>
            <li>L'envoi de notifications et d'informations sur les services,</li>
            <li>L'amélioration des fonctionnalités de la plateforme.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6">7.3. Droits du Client</h3>
          <p>Conformément au RGPD, le Client dispose des droits suivants :</p>
          <ul className="list-disc pl-6">
            <li>Droit d'accès : Consulter les données personnelles détenues par Sibyagence.</li>
            <li>Droit de rectification : Corriger ou mettre à jour ses données.</li>
            <li>Droit à l'effacement : Demander la suppression de ses données, sauf obligation légale contraire.</li>
            <li>Droit d'opposition : Refuser l'utilisation de ses données à des fins de marketing direct.</li>
            <li>Droit à la portabilité : Recevoir une copie de ses données dans un format structuré.</li>
          </ul>
          <p>Pour exercer ces droits, le Client peut contacter Sibyagence par email à contact@sibyagence.com.</p>

          <h3 className="text-xl font-semibold mt-6">7.4. Sécurité des données</h3>
          <p>Les données sont protégées par des mesures techniques et organisationnelles strictes pour prévenir tout accès non autorisé, perte ou modification.</p>

          <h3 className="text-xl font-semibold mt-6">7.5. Conservation des données</h3>
          <p>Les données sont conservées aussi longtemps que nécessaire pour les finalités prévues, conformément aux exigences légales.</p>

          <h2 className="text-2xl font-bold mt-8">8. Propriété intellectuelle</h2>
          <p>Tous les contenus présents sur Sibystock (textes, images, logiciels, marques) sont protégés par le droit de la propriété intellectuelle et restent la propriété exclusive de Sibyagence.</p>

          <h2 className="text-2xl font-bold mt-8">9. Responsabilité</h2>
          <p>Sibyagence ne saurait être tenue responsable en cas de :</p>
          <ul className="list-disc pl-6">
            <li>Non-respect des présentes CGV par le Client,</li>
            <li>Dommages liés à une mauvaise utilisation de la plateforme,</li>
            <li>Indisponibilité temporaire du service.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">10. Loi applicable et juridiction compétente</h2>
          <p>Les présentes CGV sont régies par la loi française. En cas de litige, la compétence est attribuée aux tribunaux du ressort de Lyon, sauf disposition contraire.</p>

          <h2 className="text-2xl font-bold mt-8">11. Contact</h2>
          <p>Pour toute question ou réclamation, vous pouvez nous contacter par email à contact@sibyagence.com</p>
        </div>
      </main>
    </div>
  );
}